






import { Component, Prop, Vue } from 'vue-property-decorator';
import KmyLogTagText from '@/components/parts/KmyLogTagText.vue';
import * as api from '@/api/api';
import * as def from '@/common/definitions';

@Component({
  components: {
    KmyLogTagText,
  },
})
export default class MapLogLine extends Vue {
  @Prop() private log!: api.MapLog;
  @Prop({
    default: false,
  }) private isShowBattleLog!: boolean;

  private get eventType(): def.EventType {
    const type = api.MapLog.getEventType(this.log);
    if (type) {
      return type;
    } else {
      return def.EventType.default;
    }
  }
}
